import { createContext, useEffect, useState, useCallback } from 'react'
import { IntakeContext } from './IntakeContext'
import { SessionInformation } from 'admin/utils/SessionInformation'

export const AnonymousContext = ({ children }) => {
  const [intakeState, setIntakeState] = useState({
    employmentStatus: 'employed',
    pickYourPath: 1,
    dateOfBirth: '1975-01-01',
    dateOfHire: '2005-01-01',
    dateOfPlannedRetirement: '2035-01-01',
    estimatedSocialSecurity: 2400,
    governmentEmployee: true,
    baseSalary: 80000,
    highThree: 76800,
    netTakeHome: 2200,
    // currentLeaveBalance: 244,
    // currentSickLeaveBalance: 175,
    // healthInsurance: 'fehb',
    // fehbCode: '104',
    // healthInsurancePremium: 150.79,
    // tsp: true,
    // tspContribution: 11,
    // tspLoans: false,
  })
  const updateUser = () => {
    console.log('we will use the session data over here', {
      myUser: intakeState,
    })
  }

  useEffect(() => {
    const loadUpMySession = async () => {
      const demoUserInput = await SessionInformation.getItem('demoUserInput')
      let initialState = demoUserInput || {}

      // Add in a lookup for referral code and set it on initial session load
      const params = new URLSearchParams(window.location.search)
      const refCode = params.get('ref')
      const engagementCode = params.get('engcode')

      if (refCode && !initialState.referredByCode) {
        initialState.referredByCode = refCode
        await SessionInformation.setItem('demoUserInput', initialState)
      }

      if (engagementCode && !initialState.engagementCode) {
        initialState.engagementCode = engagementCode
        await SessionInformation.setItem('demoUserInput', initialState)
      }

      // console.log(initialState)

      if (initialState) {
        setIntakeState((prev) => ({
          ...prev,
          ...initialState,
        }))
      }
    }
    loadUpMySession()
  }, [])

  const updateIntakeStateAtKey = useCallback(
    (object) => {
      setIntakeState((prevState) => ({ ...prevState, ...object }))
    },
    [setIntakeState]
  )
  return (
    <IntakeContext.Provider
      value={{
        intakeState,
        updateUser,
        isAdmin: false,
        updateIntakeStateAtKey,
        currentErrors: {},
      }}
    >
      {children}
    </IntakeContext.Provider>
  )
}
